import {
  CONSTANT_FIREBASE_BUCKET_BASE_PATH,
  CONSTANT_G_APP_NAME,
  CONSTANT_G_BASE_URL_AUTH,
  CONSTANT_G_BASE_URL_WRITE,
  CONSTANT_G_DIR_EDITED,
  CONSTANT_G_DIR_ORIGINAL,
  CONSTANT_G_DIR_TEMPLATE
} from '../constants';
import {msalInstance} from '../index';

const getWeatherDataUrl = endpoint =>
  `${process.env.REACT_APP_WEATHER_DATA_BASE_URL}/${endpoint}?key=${process.env.REACT_APP_G_AUTH_WEB_API_KEY}`;
const getReadWeatherFileUrl = (directory, filename) =>
  getWeatherDataUrl(
    `storage/${CONSTANT_G_APP_NAME}/${directory}${
      filename ? `/${filename}` : ''
    }`
  );

export const api = {
  auth: {
    getToken: `${CONSTANT_G_BASE_URL_AUTH}?key=${process.env.REACT_APP_G_AUTH_WEB_API_KEY}`
  },
  files: {
    list: getReadWeatherFileUrl(CONSTANT_G_DIR_ORIGINAL),
    readTxt: filename =>
      getReadWeatherFileUrl(CONSTANT_G_DIR_ORIGINAL, filename),
    readJson: filename =>
      getReadWeatherFileUrl(CONSTANT_G_DIR_EDITED, filename),
    readTemplate: filename =>
      getReadWeatherFileUrl(CONSTANT_G_DIR_TEMPLATE, filename),
    write: filename =>
      `${CONSTANT_G_BASE_URL_WRITE}/${process.env.REACT_APP_G_BUCKET_NAME}/o?uploadType=media&name=${CONSTANT_FIREBASE_BUCKET_BASE_PATH}/${CONSTANT_G_DIR_EDITED}/${filename}`,
    updateMetadata: filename =>
      `${CONSTANT_G_BASE_URL_WRITE}/${
        process.env.REACT_APP_G_BUCKET_NAME
      }/o/${encodeURIComponent(
        `${CONSTANT_FIREBASE_BUCKET_BASE_PATH}/${CONSTANT_G_DIR_EDITED}/${filename}`
      )}`,
    writeToApiGateway: filename =>
      `${process.env.REACT_APP_DMX_API_GATEWAY}/api/v1/exporter/design04?filename=${filename}`
  },
  moon: getWeatherDataUrl('db/mondwert/mondwert')
};

/**
 * loads json config file as object from web-api
 *
 * @param filename              relative filepath to data folder
 * @returns {Promise<object>}   return object has "error" key on error
 */
export const getData = async filename => {
  if (!filename) return {error: 'empty filepath'};

  try {
    const response = await fetch(api.files.readJson(filename));

    if (response.status !== 200) {
      return {error: response.status + ' ' + response.statusText};
    }

    return await response.json();
  } catch (err) {
    return {error: err.message};
  }
};

/**
 * loads list of all available data files
 *
 * @returns {Promise<object|array>}   return object has "error" key on error
 *                                    otherwise [{title: 'title, filepath: '/filepath.json'}]
 */
export const getList = async () => {
  const response = await fetch(api.files.list);

  if (response.status !== 200) {
    return {error: response.status + ' ' + response.statusText};
  }

  try {
    const r = await response.json();
    return r.files;
  } catch (err) {
    return {error: err.message};
  }
};

export const postData = async (filename, data) => {
  if ('mosdata_loaded' in data) delete data.mosdata_loaded;
  if ('mosdata-loaded' in data) delete data['mosdata-loaded'];

  data.lastUpdated = Date.now();
  try {
    const authResponse = await authenticate();
    await fetch(api.files.write(filename), {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${authResponse.idToken}`,
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    });
    await fetch(api.files.updateMetadata(filename), {
      method: 'PATCH',
      headers: {
        Authorization: `Bearer ${authResponse.idToken}`,
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({cacheControl: 'no-cache'})
    }).catch(error => console.error(error));

    uploadToWeatherTerminalGateway(filename, JSON.stringify(data)).catch(
      error => {
        console.error('Upload to "WetterTerminal Gateway" failed', error);
      }
    );
  } catch (error) {
    console.error('Upload to firestore failed', error);
  }
};

export const authenticate = async () =>
  fetch(api.auth.getToken, {
    method: 'post',
    body: JSON.stringify({
      email: process.env.REACT_APP_FIREBASE_AUTH_EMAIL,
      password: process.env.REACT_APP_FIREBASE_AUTH_PASSWORD,
      returnSecureToken: true
    })
  }).then(r => r.json());

export const uploadToWeatherTerminalGateway = async (
  filename,
  fileContent,
  fileType = 'jsonString'
) => {
  const response = await msalInstance.acquireTokenSilent({
    scopes: ['api://3cb3e179-b17f-4ffe-a3ce-1c0127597a18/access_as_user'],
    account: msalInstance.getActiveAccount() || msalInstance.getAllAccounts()[0]
  });

  const formData = new FormData();
  formData.append(fileType, fileContent);
  return fetch(api.files.writeToApiGateway(filename), {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${response.accessToken}`
    },
    body: formData
  })
    .then(r => console.log(r))
    .catch(e => console.error(e));
};
